import { render } from "./DisclaimerModal.vue?vue&type=template&id=0ca3b082&scoped=true"
import script from "./DisclaimerModal.vue?vue&type=script&lang=js"
export * from "./DisclaimerModal.vue?vue&type=script&lang=js"

import "./DisclaimerModal.vue?vue&type=style&index=0&id=0ca3b082&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca3b082"]])

export default __exports__